module.exports = __webpack_public_path__ + "img/mo3.e6bcf1d8.png";